import React from 'react';
import PropTypes from 'prop-types';

export default function Unauthorized({ children }) {
  return <>{children}</>;
}

Unauthorized.propTypes = {
  children: PropTypes.node.isRequired
};
